import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Projects from "./pages/Projects";
import RateCard from "./components/RateCard";
import Onboarding from "./components/OnboardingForm";
import ReadySystems from "./components/ReadySystems"; // NEW IMPORT
import Header from "./components/Header";
import SystemDetail from "./pages/SystemDetailPage";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/privacy";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="bg-white text-gray-800 dark:bg-[#010536] dark:text-white min-h-screen">
        <Header />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/rate-card" element={<RateCard />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/ready-systems" element={<ReadySystems />} /> 
            <Route path="/system/:id" element={<SystemDetail />} /> {/* NEW ROUTE */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;